/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useCallback, useContext, useState, type ReactNode } from "react"
import type { TimeClockStatus } from "../Objects/TimeClock/TimeClockStatus"
import { useTimeClock } from "../hooks/TimeClock/useTimeClock"

interface TimeClockStatusContextData {
  status: TimeClockStatus | undefined
  isLoading: boolean
  refresh: () => Promise<TimeClockStatus | undefined>
}

const TimeClockStatusContext = createContext<TimeClockStatusContextData | undefined>(undefined)

interface TimeClockStatusProviderProps {
  children: ReactNode
}

export const TimeClockStatusProvider: React.FC<TimeClockStatusProviderProps> = ({ children }) => {
  const [status, setStatus] = useState<TimeClockStatus | undefined>(undefined)

  const { getMyStatus, isLoading } = useTimeClock()

  const refresh = useCallback(async () => {
    const currentStatus = await getMyStatus()

    setStatus(currentStatus)

    return currentStatus
  }, [getMyStatus])

  return (
    <TimeClockStatusContext.Provider value={{ status, isLoading, refresh }}>{children}</TimeClockStatusContext.Provider>
  )
}

export const useTimeClockStatus = (): TimeClockStatusContextData => {
  const context = useContext(TimeClockStatusContext)

  if (!context) {
    throw new Error("useTimeClockStatus deve ser usado dentro de um TimeClockStatusProvider")
  }

  return context
}
